const OnboardingRoute = [
  {
    title: 'Profile Perusahaan',
    path: '/onboarding-client',
    isActive: 'onboarding-client',
    subtitle: 'Lengkapi profil perusahaan Anda',
  },
  {
    title: 'HUB',
    path: '/onboarding-hub',
    isActive: 'onboarding-hub',
    subtitle: 'Atur gudang tempat penyimpanan',
  },
  {
    title: 'Tipe Layanan',
    path: '/onboarding-services',
    isActive: 'onboarding-services',
    subtitle: 'Lengkapi data tipe layanan yang Anda sediakan',
  },
  {
    title: 'Harga',
    path: '/onboarding-pricing',
    isActive: 'onboarding-pricing',
    subtitle: 'Tetapkan harga baku yang Anda inginkan',
  },
  {
    title: 'Customer',
    path: '/onboarding-customer',
    isActive: 'onboarding-customer',
    subtitle: 'Masukkan data customer yang berkerjasama dengan Anda',
  },
  {
    title: 'Vendor',
    path: '/onboarding-vendor',
    isActive: 'onboarding-vendor',
    subtitle: 'Isi vendor armada untuk pengiriman barang',
  },
  {
    title: 'Driver',
    path: '/onboarding-driver',
    isActive: 'onboarding-driver',
    subtitle: 'Masukkan informasi driver Anda',
  },
  {
    title: 'Selesai',
    path: '/onboarding-finish',
    isActive: 'onboarding-finish',
    subtitle: '',
  },
];

export default OnboardingRoute;
